import { useSignOutMutation } from "@/modules/auth/services";
import { setIsAuth } from "@/modules/auth/state";
import { clearUserFromStorage } from "@/shared/helpers";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { Modal } from "@ab.uitools/ui-library/components/Modal";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useIdleTimer } from "react-idle-timer";

const IDLE_TIMEOUT = 10 * 60 * 1000;
const TIMEOUT = 60 * 1000;
const IDLE_DEBOUNCE = 500;

export const UserIdle = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const [signOut] = useSignOutMutation();
  const isAuth = useAppSelector((state) => state.auth.isAuth);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const handleSignOut = () => {
    signOut()
      .unwrap()
      .then(() => {
        clearUserFromStorage();
        dispatch(setIsAuth(false));
        window.location.reload();
      })
      .finally(() => {
        setIsOpenModal(false);
      });
  };

  const onOpenModal = () => {
    if (isAuth) {
      setIsOpenModal(true);
      timerRef.current = setTimeout(() => {
        handleSignOut();
      }, TIMEOUT);
    }
  };

  const onConfirm = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setIsOpenModal(false);
  };

  useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onIdle: onOpenModal,
    debounce: IDLE_DEBOUNCE,
  });

  return (
    <Modal
      onSubmit={onConfirm}
      titleProps={{
        title: t("general.sessionWillExpire"),
        size: "large"
      }}
      isOpen={isOpenModal}
      onClose={() => setIsOpenModal(false)}
      closeIcon
      buttonProps={{
        confirm: {
          buttonText: t("general.stayIn"),
          buttonActionType: "submit",
        },
      }}
    >
      <div>
        <Text>{t("general.youWillLoggedOut")}</Text>
      </div>
    </Modal>
  );
};
